export class DeviceParamGatewayV3FindBleLiris {
    public nb_discovery: number = 15;
    public max_err: number = 15;
    public sleep_after_discovery: number = 3;
    public wait_cmd: number = 4;
}
